import axios from "axios";

export default class HospitalApi {
  static getHospitalList = async () => {
    try {
      const res = await axios.get("/api/hospitals/select");
      return res.data.hospitals;
    }
    catch (error) {
    
    }
  }
  
  static getHospital = async (hospitalId) => {
    try {
      const res = await axios.get(`/api/hospitals/${hospitalId}`)
      return res.data
    } 
    catch (error) {

    }
  }
}